/**
 * Created by Abbes on 15/06/2017.
 */
import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AdminService} from '../admin.service';

@Injectable()
export class NotAuthorizedAdminGuard implements CanActivate {

    constructor(private adminService: AdminService, private router: Router) {
    }

    canActivate() {
        if (this.adminService.getToken()) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }

}
